import { usePostMutation } from "@/api/swr/useMutation";
import { evaluationReportCreateSchema } from "@/schema/console/evaluation-reports/EvaluationReportCreate";
import { z } from "zod";

type Config = Parameters<
  typeof usePostMutation<typeof evaluationReportCreateSchema, z.ZodNull>
>[3];

export const useCreateEvaluationReport = (id: string, config?: Config) => {
  return usePostMutation(
    evaluationReportCreateSchema,
    z.null(),
    `/console/evaluation_reports/${id}`,
    config,
  );
};
